import type { OptionTabGroup } from '@morpho-org/ui-v6/client'

import type { SectionConfig } from '@/hooks/useSectionScrollSpy'

export type MarketSubTabs = 'market' | 'rates' | 'risk' | 'activity' | 'yourPosition'

export const MARKET_SUB_TAB_OPTIONS: OptionTabGroup<MarketSubTabs>[] = [
  {
    label: 'Market',
    value: 'market'
  },
  {
    label: 'Rates',
    value: 'rates'
  },
  {
    label: 'Risk',
    value: 'risk'
  },
  {
    label: 'Activity',
    value: 'activity'
  },
  {
    label: 'Your Position',
    value: 'yourPosition'
  }
]

export const MARKET_SECTION_CONFIG: SectionConfig<MarketSubTabs>[] = MARKET_SUB_TAB_OPTIONS.map(
  o => ({ id: o.value, label: o.label })
)

export function getVisibleSections(isConnected: boolean) {
  return isConnected
    ? MARKET_SECTION_CONFIG
    : MARKET_SECTION_CONFIG.filter(s => s.id !== 'yourPosition')
}

export function getVisibleOptions(isConnected: boolean) {
  return isConnected
    ? MARKET_SUB_TAB_OPTIONS
    : MARKET_SUB_TAB_OPTIONS.filter(o => o.value !== 'yourPosition')
}
